// extracted by mini-css-extract-plugin
export var container = "_4l-0";
export var error = "_4l-9";
export var label = "_4l-5";
export var light = "_4l-6";
export var md = "_4l-3";
export var sm = "_4l-2";
export var thin = "_4l-8";
export var thinBold = "_4l-7";
export var vertical = "_4l-4";
export var xs = "_4l-1";